<template>
  <div id="app">
    <Headers></Headers>
    <div class="center">
      <div class="h1" id="topAnchor">
        <el-carousel :height="bannerHeight + 'px'" :interval="1000000">          
          <el-carousel-item>
            <img src="../assets/img/index/1-5.jpg" alt="" @click="jumpBaTiao"/>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/index/1-4.png" alt="" @click="jumpWenZhang"/>
          </el-carousel-item>
          <el-carousel-item> 
            <img src="../assets/img/index/1-6.jpg" alt="" @click="jumpFeiFaJianGu"/>
          </el-carousel-item>
          <el-carousel-item>
            <router-link :to="{ name: 'banner1' }" target="_blank">
              <img src="../assets/img/index/1-1.png" alt="" />
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <router-link :to="{ name: 'banner2' }" target="_blank">
              <img src="../assets/img/index/1-3.png" alt="" />
            </router-link>
          </el-carousel-item>
          <el-carousel-item>
            <img src="../assets/img/index/1-2.png" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <div class="lis lis1">
          <div class="text">
            <div class="text1">投诉与建议</div>
            <div class="text2">400-101-8662</div>
          </div>
        </div>
        <div class="lis lis2">
          <div class="text">
            <div class="text1">股多多热线</div>
            <div class="text2">010-66045051</div>
          </div>
        </div>
        <div class="lis lis3">
          <div class="text">
            <div class="text1">售后服务热线</div>
            <div class="text2">010-66045051</div>
          </div>
        </div>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">聚焦天相</div>
        <div class="li-2">专业、持牌咨询机构 为您保驾护航</div>
        <div class="li-3">
          <img src="../assets/img/index/h3-1.png" alt="" />
        </div>
        <div class="li-4">
          <div class="lis1" @click="to_us()">
            <div class="text1">投顾执业资格</div>
            <div class="text2">资格证编号</div>
            <div class="text3">91110102MA001GJE1N</div>
            <img src="../assets/img/index/h3-7.png" alt="" />
          </div>
          <div class="lis2">
            <div class="text1">专业投顾团队</div>
            <div class="text2">5代证券工具分析理论引导者</div>
            <img src="../assets/img/index/h3-8.png" alt="" />
          </div>
          <div class="lis3">
            <div class="text1">智能投教业务</div>
            <div class="text2">从业资深导师坐镇</div>
            <div class="text3">尊享买方投教服务</div>
            <img src="../assets/img/index/h3-10.png" alt="" />
          </div>
          <div class="lis4" @click="to_product()">
            <div class="text1">创新量化产品</div>
            <div class="text2">为用户解决选股难题</div>
            <img src="../assets/img/index/h3-9.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="h4">
      <div class="w">
        <div class="li-1">动态智能操盘系统 一站式解决炒股难题</div>
        <div class="li-2">专业 · 实战 · 智能 · 好用</div>
        <div class="li-3">
          <img src="../assets/img/index/h3-1.png" alt="" />
        </div>
        <div class="li-4">
          <div class="left">
            <img src="../assets/img/index/h4-1.png" alt="" />
          </div>
          <div class="right">
            <div class="lis1">
              <div class="l">
                <div class="p1">趋势维度——仓位管理</div>
                <div class="p2">股性维度——涨停活跃</div>
                <div class="p3">资金维度——多空量能</div>
              </div>
              <div class="r">
                <div class="p1">结合实战 大盘多空指标</div>
                <div class="p2">监控涨停 快速锁定龙头</div>
                <div class="p3">快速准确 主力动向信号</div>
              </div>
            </div>
            <div class="lis2">
              <div class="l">
                <div class="p1">超短环境——龙头股池</div>
                <div class="p2">题材先锋——龙头雷达</div>
                <div class="p3">明星机构——估值空间</div>
              </div>
              <div class="r">
                <div class="p1">龙头股五大选股模型</div>
                <div class="p2">游资机构做多合力点</div>
                <div class="p3">成长白马股一键掌握</div>
              </div>
            </div>
            <div class="lis3">
              <img
                @click="to_xaizai1()"
                style="margin-bottom:20px"
                src="../assets/img/index/1.png"
                alt=""
              />
              <img
                @click="to_xaizai2()"
                style="margin-bottom:20px"
                src="../assets/img/index/2.png"
                alt=""
              />
              <img
                @click="to_xaizai3()"
                src="../assets/img/index/3.png"
                alt=""
              />
              <img
                @click="to_xaizai5()"
                src="../assets/img/index/5.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h5">
      <div class="w">
        <div class="li-1">产品赋能 行稳致远</div>
        <div class="li-2">为投资者提供智能投顾服务 全面服务您的投资需求</div>
        <div class="li-3">
          <img src="../assets/img/index/h3-1.png" alt="" />
        </div>
        <div class="li-4">
          <div class="left">
            <img src="../assets/img/index/h5-1.png" alt="" />
          </div>
          <div class="rights">
            <img src="../assets/img/index/h5-2.png" alt="" />
          </div>
        </div>
        <div class="li-5">
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-3.png" alt="" />
            </div>
            <div class="lis-2">执证投顾 专业咨询</div>
            <div class="lis-3">
              股多多拥有专业且正规的投顾队伍，执证投顾均为行业内具备实战经验从业人员
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-4.png" alt="" />
            </div>
            <div class="lis-2">秒级数据 尽情使用</div>
            <div class="lis-3">
              股多多用户自注册软件之日起，免费使用软件数据功能，全年数据畅通无阻
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-5.png" alt="" />
            </div>
            <div class="lis-2">实时直播 胜在分秒</div>
            <div class="lis-3">
              交流、诊股、咨询，由具备实盘操作经验投顾领衔百人客服团队提供在线服务
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-6.png" alt="" />
            </div>
            <div class="lis-2">系统教学 360°培训</div>
            <div class="lis-3">
              网络教学、电话教学、课件自学......个性化教学服务，让用户通晓软件精要，运用自如
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-7.png" alt="" />
            </div>
            <div class="lis-2">3对1 全方位服务</div>
            <div class="lis-3">
              股多多付费版本用户，均能享受投顾、讲师、客服 一体化的专业团队服务
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-8.png" alt="" />
            </div>
            <div class="lis-2">股票资讯 新鲜速递</div>
            <div class="lis-3">
              为股民量身打造的股票资讯，国内领先的财经事件及股票投资机会聚合快讯
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-9.png" alt="" />
            </div>
            <div class="lis-2">多渠反馈 服务至上</div>
            <div class="lis-3">
              400热线电话、在线客服 微信公众平台等用户反馈渠道，树立行业服务新标杆
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-10.png" alt="" />
            </div>
            <div class="lis-2">原创资讯 解密软件</div>
            <div class="lis-3">
              由专业团队根据软件信号撰写原创资讯，辅助用户读懂软件，搭建证券知识学习平台
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-11.png" alt="" />
            </div>
            <div class="lis-2">全年活动 真诚回馈</div>
            <div class="lis-3">
              为更好回馈与服务用户，股多多用户可享受专属优惠活动及特色培训等服务
            </div>
          </div>
          <div class="lis">
            <div class="lis-1">
              <img src="../assets/img/index/h5-12.png" alt="" />
            </div>
            <div class="lis-2">竭诚服务 精益求精</div>
            <div class="lis-3">
              为保产品与服务质量，股多多定期对用户软件使用情况进行回访
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h6">
      <div class="w">
        <div class="li-1">数据支持</div>
        <div class="li-2">
          <img src="../assets/img/index/h3-1.png" alt="" />
        </div>
        <div class="li-3">
          <div class="lis" @click="to_shanghai()">
            <img src="../assets/img/index/h6-1.png" alt="" />
            <p class="arrow_right"></p>
          </div>
          <div class="lis" @click="to_shenzhen()">
            <img src="../assets/img/index/h6-2.png" alt="" />
            <p class="arrow_right"></p>
          </div>
          <div class="lis" @click="to_zhiye()">
            <img src="../assets/img/index/h6-3.png" alt="" />
            <p class="arrow_right"></p>
          </div>
          <div class="lis" @click="to_congye()">
            <img src="../assets/img/index/h6-4.png" alt="" />
            <p class="arrow_right"></p>
          </div>
        </div>
        <div class="li-4">
          <div class="lis1">
            <img src="../assets/img/index/s1.png" alt="" />
            <div class="text">执业投顾资质</div>
          </div>
          <img src="../assets/img/index/sss.png" alt="" />
          <div class="lis1">
            <img src="../assets/img/index/s2.png" alt="" />
            <div class="text">资深行业经验</div>
          </div>
          <img src="../assets/img/index/sss.png" alt="" />
          <div class="lis1">
            <img src="../assets/img/index/s3.png" alt="" />
            <div class="text">完整风控体系</div>
          </div>
          <img src="../assets/img/index/sss.png" alt="" />
          <div class="lis1">
            <img src="../assets/img/index/s4.png" alt="" />
            <div class="text">智能工具研发</div>
          </div>
          <img src="../assets/img/index/sss.png" alt="" />
          <div class="lis1">
            <img src="../assets/img/index/s5.png" alt="" />
            <div class="text">专业策略研究</div>
          </div>
          <img src="../assets/img/index/sss.png" alt="" />
          <div class="lis1">
            <img src="../assets/img/index/s6.png" alt="" />
            <div class="text">实战培训体系</div>
          </div>
        </div>

        <!-- 优化后的新闻资讯区域（无模拟数据） -->
        <div class="news-container">
          <div class="news-header">
            <h3 class="news-title">最新公司动态与行业资讯</h3>
          
          </div>
          
          <!-- 加载状态 -->
          <div
            class="loading-wrap"
            v-if="newsLoading"
            v-loading="newsLoading"
            element-loading-text="正在加载资讯..."
            element-loading-spinner="el-icon-loading"
          ></div>
          
          <!-- 新闻列表 -->
          <div class="news-list" v-else-if="newsList.length > 0">
            <!-- 动态列数：根据数据量自动分配 -->
            <div class="news-column" v-for="(column, colIndex) in newsColumns" :key="colIndex">
              <div class="news-item" v-for="(news, index) in column" :key="news.id">
                <a 
                  href="javascript:;"
                  class="news-link"
                  @click="goToNewsDetail(news)"
                >
                  <span class="news-number" :class="{ top3: (colIndex * columnLength) + index < 3 }">{{ (colIndex * columnLength) + index + 1 }}</span>
                  <span class="news-content">{{ news.title }}</span>
                  <span class="news-time">{{ formatTime(news.createTime || news.publishTime) }}</span>
                </a>
              </div>
            </div>
          </div>
          
          <!-- 无数据状态 -->
          <div class="empty-wrap" v-else>
            <img src="" alt="暂无资讯" class="empty-img" />
            <p class="empty-text">暂无最新公司动态与行业资讯</p>
            <router-link :to="{ name: 'news' }" class="empty-more-btn">
              前往公司动态与行业资讯列表页
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="r-card1">
      <a href="#topAnchor"><img src="../assets/img/index/r-c-2.png" alt=""/></a>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
import Headers from "../components/headers";
import Bottom from "../components/bottom";
import { videoPlayer } from "vue-video-player";
import { Message } from "element-ui";
import axios from "axios";
import "video.js/dist/video-js.css";

export default {
  name: "index",
  components: {
    Headers,
    Bottom,
    videoPlayer
  },
  data() {
    return {
      hasPrompted: localStorage.getItem("hasPrompted") || false,
      bannerHeight: 584, //图片父容器的高度
      screenWidth: 0, //屏幕的宽度
      bannerHeights: 371,
      flag: 0, // 记录播放位置
      videos: [], // 视频列表
      // 播放器相关配置
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{ type: "video/mp4", src: "" }], // 因为我们要动态加载，所以src默认为空
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      // 新闻相关数据
      newsList: [], // 接口获取的新闻数据（仅真实数据）
      newsLoading: false, // 新闻加载状态
      newsApiUrl: "https://dy01.txcfgl.net:24081/tx-api/api/v1/article/article-list", // 真实接口地址
      columnLength: 5 // 每列最多显示5条新闻
    };
  },
  computed: {
    // 动态计算新闻列数（最多3列）
    newsColumns() {
      const total = this.newsList.length;
      const columns = Math.min(Math.ceil(total / this.columnLength), 3); // 最多3列
      const result = [];
      
      // 分割数据到对应列
      for (let i = 0; i < columns; i++) {
        const start = i * this.columnLength;
        const end = start + this.columnLength;
        result.push(this.newsList.slice(start, end));
      }
      return result;
    }
  },
  mounted() {
    this.showPopup();
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
    this.getVideos();
    // 加载新闻资讯（仅真实接口数据）
    this.getNewsList();
  },
  methods: {
    jumpBaTiao() {
      this.$router.push("/batiao");
    },
    jumpWenZhang() {
      this.$router.push("/wenzhang");
    },
    jumpFeiFaJianGu() {
      this.$router.push("/feifajiangu");
    },
    showPopup() {
      // if (!this.hasPrompted) {
      //  this.$message({
      //     message: '恭喜你，这是一条成功消息',
      //     showClose: true,
      //     duration:5000
      //   });
      //   localStorage.setItem("hasPrompted", true);
      // }
    },
    setSize: function() {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (584 / 1920) * this.screenWidth;
    },
    getVideos() {
      this.videos = ["https://cdn.juniubang.com/apk/退市新规.mp4"]; // 从服务器获取视频列表
      this.playerOptions["sources"][0]["src"] = this.videos[0]; // 首先加载第一个
    },
    to_xaizai1() {
      window.open("https://cdn.juniubang.com/apk/GDD1003.exe");
    },
    to_xaizai2() {
      window.open("https://cdn.juniubang.com/apk/GDD2015.exe");
    },
    to_xaizai3() {
      window.open("https://cdn.juniubang.com/apk/GDD3001.exe");
    },
    to_xaizai5() {
      window.open("https://cdn.juniubang.com/apk/GDD5001.exe");
    },
    to_banner1() {
      this.$router.push("/banner1");
    },
    toBank() {
      this.$router.push({ path: "/userService" });
    },
    to_shanghai() {
      window.open(require("@/assets/img/上交所行情授权.jpg"));
    },
    to_shenzhen() {
      window.open(require("@/assets/img/深交所行情授权.jpg"));
    },
    to_zhiye() {
      window.open(
        "https://gs.sac.net.cn/pages/registration/new-sac-publicity-finish.html?orgId=611"
      );
    },
    to_congye() {
      window.open(
        "https://gs.sac.net.cn/pages/registration/new-sac-publicity-finish.html?orgId=611"
      );
    },
    to_us() {
      this.$router.push("/aboutUs");
    },
    to_product() {
      this.$router.push("/product");
    },

    // 获取新闻列表（仅对接真实接口，无模拟数据）
    async getNewsList() {
      this.newsLoading = true;
      try {
        const requestData = {
          pageNum: 1,
          pageSize: 15, // 最多获取15条
          category: "",// 全部分类
          status:0 
        };

        console.log("请求新闻参数:", requestData);
        console.log("请求URL:", this.newsApiUrl);

        // 调用真实接口
        const response = await axios.post(this.newsApiUrl, requestData, {
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
          }
        });

        // 根据后端实际返回格式调整
        if (response.data && response.data.code === '00000') {
          // 仅保留真实接口返回的数据（支持不同返回格式）
          this.newsList = response.data.data.records || 
                          response.data.data.list || 
                          response.data.data || 
                          [];
          console.log("获取真实新闻数据:", this.newsList);
        } else {
          this.newsList = [];
          Message.warning(response.data.message || "获取新闻失败");
        }
      } catch (error) {
        console.error("新闻接口请求失败:", error);
        this.newsList = [];
        // 接口请求失败时不显示模拟数据，仅显示无数据状态
        if (error.message.includes('timeout')) {
          Message.error("请求超时，请稍后重试");
        } else {
          Message.error("网络异常，无法获取资讯");
        }
      } finally {
        this.newsLoading = false;
      }
    },

    // 格式化时间（精简版）
    formatTime(timeStr) {
      if (!timeStr) return "";
      try {
        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return "";
        return `${date.getMonth() + 1}月${date.getDate()}日`;
      } catch (error) {
        return "";
      }
    },

    // 跳转到新闻详情页
    goToNewsDetail(news) {
      if (news.id) {
        this.$router.push({
          name: "reading",
          params: { id: news.id }
        });
      } else {
        Message.info("该资讯暂无详情页");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.video-player {
  margin: 0 auto;
  width: 700px;
  background-color: rgb(0, 0, 0);
  .video {
    object-fit: fill;
  }
  .video-js {
    height: 100%;
    padding: 0;
  }
}
.w {
  width: 1200px;
  margin: 0 auto;
}

// 右侧弹窗
.r-card-1 {
  width: 153px;
  height: 76px;
  background: url(../assets/img/index/r-c-7.png);
  position: fixed;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 65px;
  text-align: center;
  display: none;
  margin-right: 195px;
  margin-bottom: 5px;
}
.center {
  .h1 {
    cursor: pointer;
    min-width: 1200px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.r-card {
  z-index: 999;
  width: 55px;
  height: 320px;
  background-color: #dc323c;
  position: fixed;
  right: 0;
  top: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  .liss {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
    p {
      font-size: 10px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 9px;
    }
  }
  .liss1 {
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 12px;
  }
}
.r-card1 {
  width: 54px;
  height: 48px;
  position: fixed;
  right: 0;
  top: 690px;
  z-index: 999;
}

// 优化后的新闻资讯样式（无模拟数据）
.news-container {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 40px;
  padding: 25px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  position: relative;

  // 新闻头部（标题+查看更多）
  .news-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px dashed #c8171d;
  }

  .news-title {
    font-size: 24px;
    font-weight: bold;
    color: #c8171d;
    margin: 0;
  }

  .more-link {
    display: flex;
    align-items: center;
    color: #c8171d;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s;

    &:hover {
      color: #a01319;
      text-decoration: underline;
    }

    i {
      margin-left: 5px;
      font-size: 12px;
    }
  }

  // 加载状态样式
  .loading-wrap {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 无数据状态样式
  .empty-wrap {
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .empty-img {
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
      opacity: 0.6;
    }

    .empty-text {
      font-size: 16px;
      color: #999;
      margin-bottom: 25px;
    }

    .empty-more-btn {
      display: inline-block;
      padding: 8px 20px;
      background: #c8171d;
      color: #fff;
      border-radius: 4px;
      text-decoration: none;
      font-size: 14px;
      transition: background 0.3s;

      &:hover {
        background: #a01319;
        color: #fff;
      }
    }
  }

  .news-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 30px;

    .news-column {
      width: calc(33.333% - 20px);
      min-width: 280px;

      // 响应式：屏幕变小时自动调整列数
      @media (max-width: 1200px) {
        width: calc(50% - 15px);
      }

      @media (max-width: 768px) {
        width: 100%;
      }
    }

    .news-item {
      margin-bottom: 15px;
      padding-left: 5px;
      border-left: 3px solid transparent;
      transition: border-color 0.2s;

      &:hover {
        border-left-color: #c8171d;
      }

      .news-link {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #333;
        font-size: 15px;
        line-height: 1.8;
        width: 100%;
        cursor: pointer;

        &:hover {
          color: #c8171d;
        }

        .news-number {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          background: #e5e5e5;
          color: #666;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 12px;
          flex-shrink: 0;
          transition: all 0.3s;
        }

        // 前三名特殊样式
        .news-number.top3 {
          background: #c8171d;
          color: #fff;
          font-weight: bold;
        }

        .news-content {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 10px;

          &:hover {
            text-decoration: underline;
          }
        }

        .news-time {
          font-size: 12px;
          color: #999;
          white-space: nowrap;
        }
      }
    }
  }
}

.h2 {
  width: 100%;
  height: 111px;
  .w {
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .lis {
      width: 341px;
      height: 88px;
      .text {
        padding-top: 22px;
        padding-left: 159px;
        .text1 {
          font-size: 22px;
        }
        .text2 {
          font-size: 16px;
        }
      }
    }
    .lis1 {
      background: url(../assets/img/index/h2-1.png);
    }
    .lis2 {
      background: url(../assets/img/index/h2-2.png);
    }
    .lis3 {
      background: url(../assets/img/index/h2-3.png);
    }
  }
}
.h3 {
  height: 605px;
  width: 100%;
  .w {
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 41px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #c8171d;
      padding-top: 40px;
      margin-bottom: 14px;
    }
    .li-2 {
      margin-bottom: 33px;
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #666666;
    }
    .li-3 {
      margin-bottom: 9px;
    }
    .li-4 {
      width: 1200px;
      height: 406px;
      background: url(../assets/img/index/h3-2.png);
      background-size: 100% 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .lis1 {
        width: 270px;
        height: 353px;
        background: url(../assets/img/index/h3-3.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text1 {
          font-size: 27px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          padding-top: 46px;
          margin-bottom: 20px;
        }
        .text2,
        .text3 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
        img {
          margin-top: 50px;
        }
      }
      .lis1:hover {
        background: url(../assets/img/index/h3-3s.png);
      }
      .lis2 {
        width: 270px;
        height: 312px;
        background: url(../assets/img/index/h3-4.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text1 {
          padding-top: 72px;
          margin-bottom: 20px;
          font-size: 27px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }
        .text2,
        .text3 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
        img {
          margin-top: 47px;
        }
      }
      .lis2:hover {
        background: url(../assets/img/index/h3-4s.png);
      }
      .lis3 {
        width: 270px;
        height: 340px;
        background: url(../assets/img/index/h3-5.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text1 {
          padding-top: 55px;
          margin-bottom: 14px;
          font-size: 27px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }
        .text2,
        .text3 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
        img {
          margin-top: 40px;
        }
      }
      .lis3:hover {
        background: url(../assets/img/index/h3-5s.png);
      }
      .lis4 {
        width: 270px;
        height: 320px;
        background: url(../assets/img/index/h3-6.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .text1 {
          padding-top: 86px;
          margin-bottom: 13px;
          font-size: 27px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }
        .text2,
        .text3 {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
        img {
          margin-top: 43px;
        }
      }
      .lis4:hover {
        background: url(../assets/img/index/h3-6s.png);
      }
    }
  }
}
.h4 {
  width: 100%;
  height: 822px;
  .w {
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      padding-top: 54px;
      font-size: 41px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #c8171d;
    }
    .li-2 {
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #666666;
      margin-bottom: 25px;
    }
    .li-4 {
      width: 100%;
      display: flex;
      .left {
        margin-right: 72px;
      }
      .right {
        padding-top: 44px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lis1 {
          width: 526px;
          height: 129px;
          background: url(../assets/img/index/h4-2.png);
          background-size: 100% 100%;
          margin-bottom: 37px;
          display: flex;
          justify-content: space-evenly;
          .l {
            width: 181px;
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #a90000;
            padding-top: 45px;
          }
          .r {
            padding-top: 45px;
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #707070;
          }
        }
        .lis2 {
          width: 526px;
          height: 129px;
          background: url(../assets/img/index/h4-3.png);
          background-size: 100% 100%;
          margin-bottom: 52px;
          display: flex;
          justify-content: space-evenly;
          .l {
            width: 181px;
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #a90000;
            padding-top: 45px;
          }
          .r {
            font-size: 17px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #707070;
            padding-top: 45px;
          }
        }
        .lis3 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
      }
    }
  }
}
.h5 {
  width: 100%;
  height: 1396px;
  .w {
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 41px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #c8171d;
      padding-top: 37px;
      margin-bottom: 14px;
    }
    .li-2 {
      margin-bottom: 27px;
      font-size: 20px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #666666;
    }
    .li-3 {
      margin-bottom: 83px;
    }
    .li-4 {
      width: 100%;
      display: flex;
      align-items: center;
      .rights {
        margin-left: -110px;
        border: 5px solid #fafafa;
        border-radius: 3px;
        width: 675px;
        height: 362px;
      }
    }
    .li-5 {
      width: 100%;
      height: 743px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      .lis {
        width: 205px;
        height: 270px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lis-1 {
          padding-top: 18px;
          margin-bottom: 18px;
        }
        .lis-2 {
          margin-bottom: 16px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #2a3c66;
          line-height: 18px;
        }
        .lis-3 {
          width: 152px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #625b5b;
        }
      }
    }
  }
}
.h6 {
  width: 100%;
  height: auto;
  padding-bottom: 40px;
  .w {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      font-size: 41px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #c8171d;
    }
    .li-2 {
      margin-bottom: 67px;
      margin-top: 10px;
    }
    .li-3 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .arrow_right {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #ccc;
        font-size: 0;
        line-height: 0;
        transform: rotate(90deg);
      }
      .lis {
        width: 273px;
        height: 71px;
        border: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .lis:hover {
        border: 1px solid #c8171d;
        .arrow_right {
          border-bottom: 10px solid #c8171d;
        }
      }
    }
    .li-4 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 114px;
      flex-wrap: wrap;
      gap: 20px 10px;
      .lis1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
      }
      .text {
        margin-top: 23px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #737272;
        line-height: 18px;
      }
    }
  }
}

// 响应式适配优化
@media (max-width: 1200px) {
  .w {
    width: 95%;
  }
  
  .h3 .li-4,
  .h4 .li-4,
  .h5 .li-4 {
    width: 100%;
    flex-wrap: wrap;
  }
  
  .h4 .li-4 .left {
    margin-right: 0;
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue